import { React, useEffect, useState } from "react";
import axios from "axios";
import { serverUrl } from "../../../Constant/Static/config";

function StaffInfo() {
  const [data, setData] = useState();
  const [grandTotal, setGrandTotal] = useState();

  const fetchData = async () => {
    try {
      const response = await axios.get(`${serverUrl}/api/admin/cv/status`);
      setData(response.data.result);
      setGrandTotal(response.data.total);
      // console.log("response : ", response.data.total);
    } catch (err) {
      // console.log("error", err);
    }
  };

  // useEffect(()=>{
  //   const totals = data.reduce(
  //     (acc, row) => ({
  //       pending: acc.pending + (row.pending || 0),
  //       verified: acc.verified + (row.verified || 0),
  //       waiting_list: acc.waiting_list + (row.waiting_list || 0),
  //       not_eligible: acc.not_eligible + (row.not_eligible || 0)
  //     }),
  //     { pending: 0, verified: 0, waiting_list: 0, not_eligible: 0 }
  //   );
  //   setGrandTotal(totals);
  // },[data])
  return (
    <div className="student-table-wrapper">
      <div className="ProceedButton" style={{ display: "flex", justifyContent: "center" }}>
        <button style={{ backgroundColor: "#218838" }} onClick={fetchData}>Load Data</button>
      </div>

      <div className="student-table-container">
        <table className="student-responsive-table">
          <thead>
            <tr>
              <th>S No.</th>
              <th>User ID</th>
              <th>Staff Name</th>
              <th style={{ width: "130px", textAlign: "center" }}>Pending</th>
              <th style={{ width: "130px" }}>Verified</th>
              <th>Waiting List</th>
              <th style={{ width: "130px", textAlign: "center" }}>Not Eligible</th>
              <th style={{ width: "130px", textAlign: "center" }}>Total</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(data) && data.length > 0 ? (
              <>
                {data.map((row, index) => (
                  <tr key={index + 1}>
                    <td>{index + 1}</td>
                    <td>{row.id}</td>
                    <td>{row.name}</td>
                    <td style={{ width: "130px", textAlign: "center" }}>{row.pending}</td>
                    <td style={{ width: "130px" }}>{row.verified}</td>
                    <td>{row.waiting_list}</td>
                    <td style={{ width: "130px", textAlign: "center" }}>{row.not_eligible}</td>
                    <td style={{ width: "130px", textAlign: "center" }}>{row.total}</td>
                  </tr>
                ))}
                <tr key='total'>
                  <td></td>
                  <td></td>
                  <td >Total</td>
                  <td style={{ width: "130px", textAlign: "center" }}>{grandTotal.grandTotalPending}</td>
                  <td style={{ width: "130px" }}>{grandTotal.grandTotalVerified}</td>
                  <td>{grandTotal.grandTotalWaitingList}</td>
                  <td style={{ width: "130px", textAlign: "center" }}>{grandTotal.grandTotalNotEligible}</td>
                  <td style={{ width: "130px", textAlign: "center" }}>{grandTotal.grandTotal}</td>
                </tr>
              </>
            ) : (
              <tr>
                <td colSpan="11">No data available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default StaffInfo;
